/**
 * zgCalculateDistance
 *
 *   Calculate distance between to places based on their coordinates.
 *   Uses the 'haversine' formula
 *
 *
 * @author: David Pocina <dpocina[at]zerogrey[dot]com>
 *
 */

(function () { /* global _ */
  'use strict'

  // Establish the root object (`window` in the browser)
  const root = this

  // === Math.PI / 180
  const deg2rad = 0.017_453_292_519_943_295

  // Diameter of the earth (in km)
  const diam = 12_742

  /**
	 *
	 * @param {Object} a
	 * @param {Object} b
	 * @returns {null|number}
	 */
  const calculateDistance = function (a, b) {
    let distance

    if (__validate(a) && __validate(b)) {
      distance = __getDistance((Number(a.lat) * deg2rad), (Number(b.lat) * deg2rad), (Number(a.lng) * deg2rad), (Number(b.lng) * deg2rad))
    }

    return __format(distance)
  }

  /**
	 * round the result to 2 decimals
	 *
	 * @param {number=} distance
	 * @returns {number|null}
	 * @private
	 */
  var __format = function (distance) {
    let result = null

    if (_.isNumber(distance)) {
      result = Math.round(distance * 100) / 100
    }

    return result
  }

  /**
	 * Calculate the distance in km using the 'haversine' formula
	 *
	 * @param {number} radLatA
	 * @param {number} radLatB
	 * @param {number} radLngA
	 * @param {number} radLngB
	 * @returns {number}
	 * @private
	 */
  var __getDistance = function (radLatA, radLatB, radLngA, radLngB) {
    const distance = (
      (1 - Math.cos(radLatB - radLatA)) +
				(1 - Math.cos(radLngB - radLngA)) * Math.cos(radLatA) * Math.cos(radLatB)
    ) / 2

    return (diam * Math.asin(Math.sqrt(distance)))
  }

  /**
	 *
	 * @param {Object} obj
	 * @returns {boolean}
	 * @private
	 */
  var __validate = function (obj) {
    let valid = false

    if (obj && !isNaN(obj.lat) && !isNaN(obj.lng)) {
      valid = true
    }

    return valid
  }

  // -----------------------------------------------------------------------------------------------------------------

  root.zgStoreLocatorCalculateDistance = calculateDistance
}).call(this)
